import React from "react";
import { Empty, Flex } from "antd/lib";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Legend, Tooltip } from "recharts";
import { ITinyBarChart, IStackedBarChartRowField } from "../../interfaces/dashboard";
const formatterUS = new Intl.NumberFormat('en-US');

interface StackedBarChartProps {
  data: ITinyBarChart[];
  rowsField: IStackedBarChartRowField[];
  fieldName?: string;
  height?: number;
  loading?: boolean;
}

const StackedBarChart: React.FC<StackedBarChartProps> = ({
  data = [],
  height = 350,
  rowsField = [],
  fieldName = "name",
  loading = false,
}) => {
  const renderCustomLegend = () => (
    <Flex
      className="legend"
      justify="center"
      wrap={true}
    >
      {rowsField.map((row) => (
        <Flex key={row.field} align="center" gap={5}>
          <div
            style={{
              backgroundColor: row.color,
              width: 8,
              height: 8,
            }}
          />
          {row.name}
        </Flex>
      ))}
    </Flex>
  );

  const renderCustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload?.length) {
      const total = payload.reduce((sum: number, item: any) => sum + (item?.value ?? 0), 0);
      return (
        <div
          style={{
            background: "#fff",
            padding: 10,
            fontSize: 14,
            boxShadow: "0 5px 26px rgba(0,0,0,0.2)",
            borderRadius: 5,
          }}
        >
          <p style={{ marginBottom: 6, fontWeight: "bold" }}>{label}</p>
          {payload.map((entry: any) => {
            const findPayload = rowsField.find((row) => row.field === entry.dataKey);
            return (
              <div key={entry.dataKey} style={{ color: entry.color }}>
                {findPayload?.name}:{" "}
                <strong>
                  {formatterUS.format(entry.value)} {total > 0 && <>({Math.round((entry.value * 100) / total)}%)</>}
                </strong>
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  };

  if (data.length === 0 && !loading) {
    return <Empty description="No Data" style={{ marginTop: "30px" }} />;
  }
  if (data.length > 0) {
    return (
      <ResponsiveContainer width="100%" height={height}>
        <BarChart layout="vertical" data={data} margin={{ top: 0, right: 0, left: 1, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" orientation="top" tick={{ fontSize: 14 }} />
          <YAxis dataKey={fieldName} type="category" width={175} tick={{ fontSize: 12 }} />
          <Tooltip content={renderCustomTooltip} />
          <Legend content={renderCustomLegend} />
          {rowsField.map((row) => (
            <Bar key={row.field} dataKey={row.field} fill={row.color} stackId="a"></Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    );
  }
  return <></>;
};

export default React.memo(StackedBarChart);
